import * as defaultImport from "@splunk/react-icons/Square";
export * from "@splunk/react-icons/Square";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
